import { CircularProgress } from '@mui/material'

function Button({ label, type, icon = null, classie, size, className, children, loading = false, ...props }) {

  return (
    <button
      type="button"
      className={`pvt-btn custom pvt-btn-${type} ${classie} size-${size} ${className ? className : ""}`}
      {...props}
      disabled={loading || props?.disabled}
    >
      {loading ? <LoadingButtonContent /> : <ButtonContent children={children} icon={icon} label={label} />}
    </button>
  );
}

const LoadingButtonContent = () => {
  return (
    <CircularProgress
      color="secondary"
      sx={{
        animation: "none",
        WebkitAnimation: "none",
        width: "unset !important",
        height: "unset !important",
      }}
    />
  );
};

const ButtonContent = ({ children, icon, label }) => {
  return (
    <>
      {children}
      {icon}
      {label}
    </>
  );
};

export default Button
